// extracted by mini-css-extract-plugin
export default {"bottomSlide":"index_bottomSlide_yukb-","logo":"index_logo_nPSl6","botton":"index_botton_x43zK"};